import React from "react";

/**
 * Logo con corona generata via Gemini Nano Banana (ispirata all'immagine di Rocco).
 * L'immagine è servita da /crown.png.
 */
export const Logo = ({ size = "md", className = "", tone = "dark" }) => {
  const sizeMap = {
    sm: { base: "text-lg", zar: "text-xl", crownH: 22 },
    md: { base: "text-2xl", zar: "text-3xl", crownH: 32 },
    lg: { base: "text-4xl", zar: "text-5xl", crownH: 52 },
    xl: { base: "text-6xl md:text-7xl", zar: "text-7xl md:text-8xl", crownH: 76 },
  };
  const s = sizeMap[size] || sizeMap.md;
  const baseColor = tone === "light" ? "text-white" : "text-midnight";

  return (
    <div className={`inline-flex items-baseline gap-0 select-none brand-shine-wrap ${className}`} data-testid="brand-logo">
      <span className={`brand-logo brand-shine brand-metallic ${s.base}`}>Guz</span>
      <span className="brand-zar-group relative inline-block">
        <span className="brand-crown-wrap">
          <img
            src="/crown.png"
            alt=""
            aria-hidden="true"
            style={{ height: `${s.crownH}px` }}
            className="brand-crown-img"
          />
        </span>
        <span className={`brand-zar-letters brand-shine ${s.zar}`}>ZAR</span>
      </span>
      <span className={`brand-logo brand-shine brand-metallic ${s.base}`}>della</span>
    </div>
  );
};

export default Logo;
